import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from '../components/Sidebar';
import GameMenu from '../components/GameMenu';
import Timer from '../components/Timer';
import EndGameBtn from '../components/EndGameBtn';
import Popup from '../components/Popup';
import LeaveGamePopup from "../components/LeaveGamePopup";
import '../assets/css/mixedwords.css'
import AnimatedBg from "../components/AnimatedBg";

const GRID_SIZE = 10;
const MOTS_db = ["cat", "home", "apple", "car"];
const MOTS = MOTS_db.map(item => item.toUpperCase())


export default function MixedWords() {
    const [timerIsFinished, setTimerIsFinished] = useState(false);
    const [timeElapsed, setTimeElapsed] = useState(0);

    const sendTime = (time) => {
        console.log(time)
        setTimeElapsed(time);
    };

    const getTimerTimeRef = useRef(null);

    const [leaveGamePopup, setLeaveGamePopup] = useState(false);

    const sendLeaveGame = (value) => {
        setLeaveGamePopup(value);
    };

    const [grid, setGrid] = useState([]);
    const [motsPlaces, setMotsPlaces] = useState([]);
    const [selection, setSelection] = useState({ start: null, end: null });
    const [selectedCells, setSelectedCells] = useState([]);
    const [wrongWords, setWrongWords] = useState([]);
    const [foundWords, setFoundWords] = useState([]);
    const [highlightedCells, setHighlightedCells] = useState([]);
    const cellRefs = useRef([]);
    const [errorCount, setErrorCount] = useState(0);

    const location = useLocation();
    const { theme, subTheme } = location.state || {};

    useEffect(() => {
        function generateGrid(size, words) {
            const grid = Array.from({ length: size }, () =>
                Array.from({ length: size }, () => "")
            );

            const positions = [];

            for (const word of words) {
                let placed = false;
                let attempts = 0;

                while (!placed && attempts < 100) {
                const dir = Math.random() < 0.5 ? "H" : "V";
                const row = Math.floor(Math.random() * size);
                const col = Math.floor(Math.random() * size);

                if (canPlaceWord(grid, word, row, col, dir)) {
                    placeWord(grid, word, row, col, dir);
                    positions.push({ word, row, col, dir });
                    placed = true;
                }
                attempts++;
                }
            }

            // Remplir les cases vides avec des lettres aléatoires
            const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            for (let r = 0; r < size; r++) {
                for (let c = 0; c < size; c++) {
                if (grid[r][c] === "") {
                    grid[r][c] = alphabet[Math.floor(Math.random() * alphabet.length)];
                }
                }
            }

            return { grid, positions };
            }
        
        
        const { grid: newGrid, positions } = generateGrid(GRID_SIZE, MOTS);
        setGrid(newGrid);
        setMotsPlaces(positions.map(p => p.word));
    }, []);

    useEffect(() => {
        if (foundWords.length === MOTS.length) {
            console.log('FIN DU JEU');
            setTimerIsFinished(true);
            // Tu peux mettre ici d'autres actions à faire à la fin
        }
    }, [foundWords]);

    const checkErrors = () => {
        if (foundWords !== motsPlaces.length) {
            let errorsToAdd = (motsPlaces.length - foundWords.length)
            setErrorCount((prev) => prev + errorsToAdd);
        }
    }

    useEffect(() => {
        // Action au montage (arrivée sur la page)
        return () => {
        // Action au démontage (quitte la page)
        const lines = document.querySelectorAll('.missing-word-line');
        lines.forEach(line => line.remove());
        console.log("Page quittée !");
        };
    }, [location.pathname]);

    function canPlaceWord(grid, word, row, col, dir) {
      const size = grid.length;

      if (dir === "H") {
        if (col + word.length > size) return false;
        for (let i = 0; i < word.length; i++) {
          const cell = grid[row][col + i];
          if (cell !== "" && cell !== word[i]) return false;
        }
      } else {
        if (row + word.length > size) return false;
        for (let i = 0; i < word.length; i++) {
          const cell = grid[row + i][col];
          if (cell !== "" && cell !== word[i]) return false;
        }
      }

      return true;
    }

    function placeWord(grid, word, row, col, dir) {
      if (dir === "H") {
        for (let i = 0; i < word.length; i++) {
          grid[row][col + i] = word[i];
        }
      } else {
        for (let i = 0; i < word.length; i++) {
          grid[row + i][col] = word[i];
        }
      }
    }

    function drawMissingWordLine(startCell, endCell) {
        var startRect = startCell.getBoundingClientRect();
        var endRect = endCell.getBoundingClientRect();

        var x1 = startRect.left + startRect.width / 2;
        var y1 = startRect.top + startRect.height / 2;
        var x2 = endRect.left + endRect.width / 2;
        var y2 = endRect.top + endRect.height / 2;

        var angle = Math.atan2(y2 - y1, x2 - x1);
        var length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

        var missingWordLine = document.createElement('div');
        missingWordLine.classList.add('missing-word-line');

        if (startCell.getAttribute('data-y') === endCell.getAttribute('data-y')) {
            missingWordLine.style.width = `${length + 40}px`; //30
            missingWordLine.style.transform = `rotate(${angle}rad)`;
            missingWordLine.style.left = `${x1 - 379}px`; //0
            missingWordLine.style.top = `${y1 - 100}px`;  //35 then 40
            console.log("1")
        } else if (startCell.getAttribute('data-y') > endCell.getAttribute('data-y') && startCell.getAttribute('data-x') !== endCell.getAttribute('data-x')) {
            missingWordLine.style.width = `${length + 30}px`;
            missingWordLine.style.transform = `rotate(${angle}rad)`;
            missingWordLine.style.left = `${x1 + 11}px`;
            missingWordLine.style.top = `${y1 - 28}px`;
            console.log("2")  
        } else if (startCell.getAttribute('data-y') < endCell.getAttribute('data-y') && startCell.getAttribute('data-x') !== endCell.getAttribute('data-x')) {
            missingWordLine.style.width = `${length + 30}px`;
            missingWordLine.style.transform = `rotate(${angle}rad)`;
            missingWordLine.style.left = `${x1 - 11}px`;
            missingWordLine.style.top = `${y1 - 29}px`; 
            console.log("3") 
        } else {
            missingWordLine.style.width = `${length + 40}px`; //30
            missingWordLine.style.transform = `rotate(${angle}rad)`;
            missingWordLine.style.left = `${x1 - 399}px`; //16 then 21
            missingWordLine.style.top = `${y1 - 80}px`;  //20
            console.log("4")
        }

        missingWordLine.style.transformOrigin = '0 50%';
        var testMixed = document.getElementById('mixedwords_grid_container')
        testMixed.appendChild(missingWordLine);
        // document.body.appendChild(missingWordLine);
    }

    // HANDLE SELECTION
    const handleMouseDown = (x, y) => {
        setSelection({ start: { x, y }, end: null });
        setSelectedCells([{ x, y }]);
    };

    const handleMouseEnter = (x, y) => {
        if (!selection.start) return;

        const newEnd = { x, y };
        const cells = getCellsBetween(selection.start, newEnd);
        if (cells) {
            setSelection({ ...selection, end: newEnd });
            setSelectedCells(cells);
        }
    };

    const handleMouseUp = () => {
        if (selectedCells.length > 0) {
            const selectedWord = selectedCells.map(cell => grid[cell.x][cell.y]).join("");
            console.log("Mot sélectionné :", selectedWord);

            const reversedWord = selectedWord.split("").reverse().join("");
            if (MOTS.includes(selectedWord) || MOTS.includes(reversedWord)) {
                const matched = MOTS.includes(selectedWord) ? selectedWord : reversedWord;
                console.log("✅ It's a match !");
                if (!foundWords.includes(matched)) {
                    setFoundWords(prev => [...prev, matched]);
                    setHighlightedCells(prev => [...prev, ...selectedCells])
                    const start = selectedCells[0];
                    const end = selectedCells[selectedCells.length - 1];
                    drawMissingWordLine(cellRefs.current[start.x][start.y], cellRefs.current[end.x][end.y]);
                }
            } else {
                console.log("❌ Wrong :(");
                if (selectedWord.length > 3) {
                    setWrongWords(prev => [...prev, selectedWord]);
                    setErrorCount((prev) => prev + 1);
                }
            }
        }

        setSelection({ start: null, end: null });
        setSelectedCells([]);
    };

    // Récupère les cellules entre deux points dans une ligne/colonne/diagonale
    function getCellsBetween(start, end) {
        const dx = end.x - start.x;
        const dy = end.y - start.y;

        const length = Math.max(Math.abs(dx), Math.abs(dy));

        const stepX = dx === 0 ? 0 : dx / Math.abs(dx);
        const stepY = dy === 0 ? 0 : dy / Math.abs(dy);

        // Valide seulement si H, V ou diagonale
        if (
            !(dx === 0 || dy === 0 || Math.abs(dx) === Math.abs(dy))
        ) {
            return null;
        }

        const cells = [];
        for (let i = 0; i <= length; i++) {
            const x = start.x + i * stepX;
            const y = start.y + i * stepY;
            if (x >= 0 && y >= 0 && x < GRID_SIZE && y < GRID_SIZE) {
                cells.push({ x, y });
            }
        }

        return cells;
    }

    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container inGame" id="mixedWords">
                <div className="title">
                    <h4>{theme} - {subTheme} </h4>
                    <div className="level-infos">
                        <Timer 
                            timer={timerIsFinished} 
                            onFinish={() => {
                                checkErrors() 
                                setTimerIsFinished(true)
                            }} 
                            onSendTime={sendTime} 
                            onGetTime={(getTimeFn) => getTimerTimeRef.current = getTimeFn}
                            hasLimit={false}
                        />
                    </div>
                </div>

                <div className="game-container launched">
                    <div className="mixedwords_game_container launched">
                        <div id="mixedwords_failed_words_container" className="mixedwords_failed_word_container">
                            {wrongWords.map((mot, index) => (
                              <span key={index} className="wrong-word">{mot}</span>
                            ))}
                        </div>

                        <div className="flex-grow-1" id="mixedwords_grid_container">
                            <div className="grid">
                                {grid.map((row, x) =>
                                  row.map((cell, y) => {
                                      const isSelected = selectedCells.some(c => c.x === x && c.y === y);
                                      return (
                                          <div
                                              className={`cell justify-content-center ${isSelected ? "selected" : ""} ${highlightedCells.some(c => c.x === x && c.y === y) ? "text-white" : ""}`}
                                              key={`${x}-${y}`}
                                              onMouseDown={() => handleMouseDown(x, y)}
                                              onMouseEnter={() => handleMouseEnter(x, y)}
                                              onMouseUp={handleMouseUp}
                                              data-x={x}
                                              data-y={y}
                                              ref={(el) => {
                                                if (!cellRefs.current[x]) cellRefs.current[x] = [];
                                                cellRefs.current[x][y] = el;
                                              }}
                                          >
                                              {cell}
                                          </div>
                                      );
                                  })
                              )}
                            </div>
                        </div>
                        
                        <div id="mixedwords_words_container" className="mixedwords_word_container">
                            {MOTS.map((mot, idx) =>
                                motsPlaces.includes(mot) ? (
                                    <span
                                        className={`word ${foundWords.includes(mot) ? "filled" : ""}`}
                                        data-word={mot}
                                        key={idx}
                                    >
                                        {mot}
                                    </span>
                                ) : null
                            )}
                        </div>
                    </div>
                </div>
                <EndGameBtn onClick={() => {
                    if (getTimerTimeRef.current) {
                        const currentTime = getTimerTimeRef.current();
                        sendTime(currentTime);
                    }
                    checkErrors();
                    setTimerIsFinished(true);
                }} />
            </div>

            <AnimatedBg />
            <GameMenu onSendLeaveGame={sendLeaveGame}/>
            <Popup time={timeElapsed} timerIsFinished={timerIsFinished} errorCount={errorCount} />
            <LeaveGamePopup popupOpen={leaveGamePopup} onSendLeaveGame={sendLeaveGame} />
        </div>
    )
}

// import React, { useEffect, useState, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from '../components/Sidebar';
// import GameMenu from '../components/GameMenu';
// import Timer from '../components/Timer';
// import EndGameBtn from '../components/EndGameBtn';
// import Popup from '../components/Popup';
// import LeaveGamePopup from "../components/LeaveGamePopup";
// import '../assets/css/mixedwords.css'
// import AnimatedBg from "../components/AnimatedBg";

// const GRID_SIZE = 10;
// const MOTS_db = ["cat", "home", "apple", "car"];
// const MOTS = MOTS_db.map(item => item.toUpperCase());

// export default function MixedWords() {
//     const [timerIsFinished, setTimerIsFinished] = useState(false);
//     const [timeElapsed, setTimeElapsed] = useState(0);

//     const sendTime = (time) => {
//         console.log(time);
//         setTimeElapsed(time);
//     };

//     const getTimerTimeRef = useRef(null);
//     const [leaveGamePopup, setLeaveGamePopup] = useState(false);

//     const sendLeaveGame = (value) => {
//         setLeaveGamePopup(value);
//     };

//     const [grid, setGrid] = useState([]);
//     const [motsPlaces, setMotsPlaces] = useState([]);
//     const [selection, setSelection] = useState({ start: null, end: null });
//     const [selectedCells, setSelectedCells] = useState([]);
//     const [wrongWords, setWrongWords] = useState([]);
//     const [foundWords, setFoundWords] = useState([]);
//     const [highlightedCells, setHighlightedCells] = useState([]);
//     const cellRefs = useRef([]);
//     const [errorCount, setErrorCount] = useState(0);

//     const location = useLocation();
//     const { theme, subTheme } = location.state || {};

//     useEffect(() => {
//         function generateGrid(size, words) {
//             const grid = Array.from({ length: size }, () =>
//                 Array.from({ length: size }, () => "")
//             );

//             const directions = [
//                 { name: "H", dx: 0, dy: 1 },   // → Gauche → Droite
//                 { name: "HR", dx: 0, dy: -1 }, // ← Droite → Gauche
//                 { name: "V", dx: 1, dy: 0 },   // ↓ Haut → Bas
//                 { name: "VR", dx: -1, dy: 0 }, // ↑ Bas → Haut
//                 { name: "D1", dx: 1, dy: 1 },  // ↘️ Diagonale principale
//                 { name: "D1R", dx: -1, dy: -1 }, // ↖️ Diagonale principale inversée
//                 { name: "D2", dx: 1, dy: -1 }, // ↙️ Diagonale secondaire
//                 { name: "D2R", dx: -1, dy: 1 }, // ↗️ Diagonale secondaire inversée
//             ];

//             const positions = [];

//             for (const word of words) {
//                 let placed = false;
//                 let attempts = 0;

//                 while (!placed && attempts < 200) {
//                     const dir = directions[Math.floor(Math.random() * directions.length)];
//                     const row = Math.floor(Math.random() * size);
//                     const col = Math.floor(Math.random() * size);

//                     if (canPlaceWord(grid, word, row, col, dir.dx, dir.dy)) {
//                         placeWord(grid, word, row, col, dir.dx, dir.dy);
//                         positions.push({ word, row, col, dir: dir.name });
//                         placed = true;
//                     }

//                     attempts++;
//                 }
//             }

//             // Remplir les cases vides avec des lettres aléatoires
//             const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//             for (let r = 0; r < size; r++) {
//                 for (let c = 0; c < size; c++) {
//                     if (grid[r][c] === "") {
//                         grid[r][c] = alphabet[Math.floor(Math.random() * alphabet.length)];
//                     }
//                 }
//             }

//             return { grid, positions };
//         }

//         function canPlaceWord(grid, word, row, col, dx, dy) {
//             const size = grid.length;

//             for (let i = 0; i < word.length; i++) {
//                 const newRow = row + i * dx;
//                 const newCol = col + i * dy;

//                 if (
//                     newRow < 0 || newRow >= size ||
//                     newCol < 0 || newCol >= size
//                 ) {
//                     return false;
//                 }

//                 const cell = grid[newRow][newCol];
//                 if (cell !== "" && cell !== word[i]) return false;
//             }

//             return true;
//         }

//         function placeWord(grid, word, row, col, dx, dy) {
//             for (let i = 0; i < word.length; i++) {
//                 grid[row + i * dx][col + i * dy] = word[i];
//             }
//         }

//         const { grid: newGrid, positions } = generateGrid(GRID_SIZE, MOTS);
//         setGrid(newGrid);
//         setMotsPlaces(positions.map(p => p.word));
//     }, []);

//     useEffect(() => {
//         if (foundWords.length === MOTS.length) {
//             console.log('FIN DU JEU');
//             setTimerIsFinished(true);
//         }
//     }, [foundWords]);

//     const checkErrors = () => {
//         if (foundWords !== motsPlaces.length) {
//             let errorsToAdd = (motsPlaces.length - foundWords.length);
//             setErrorCount((prev) => prev + errorsToAdd);
//         }
//     };

//     useEffect(() => {
//         return () => {
//             const lines = document.querySelectorAll('.missing-word-line');
//             lines.forEach(line => line.remove());
//             console.log("Page quittée !");
//         };
//     }, [location.pathname]);

//     function drawMissingWordLine(startCell, endCell) {
//         var startRect = startCell.getBoundingClientRect();
//         var endRect = endCell.getBoundingClientRect();

//         var x1 = startRect.left + startRect.width / 2;
//         var y1 = startRect.top + startRect.height / 2;
//         var x2 = endRect.left + endRect.width / 2;
//         var y2 = endRect.top + endRect.height / 2;

//         var angle = Math.atan2(y2 - y1, x2 - x1);
//         var length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

//         var missingWordLine = document.createElement('div');
//         missingWordLine.classList.add('missing-word-line');

//         missingWordLine.style.width = `${length + 30}px`;
//         missingWordLine.style.transform = `rotate(${angle}rad)`;
//         missingWordLine.style.left = `${x1 - 380}px`;
//         missingWordLine.style.top = `${y1 - 100}px`;
//         missingWordLine.style.transformOrigin = '0 50%';

//         var testMixed = document.getElementById('mixedwords_grid_container');
//         testMixed.appendChild(missingWordLine);
//     }

//     const handleMouseDown = (x, y) => {
//         setSelection({ start: { x, y }, end: null });
//         setSelectedCells([{ x, y }]);
//     };

//     const handleMouseEnter = (x, y) => {
//         if (!selection.start) return;
//         const newEnd = { x, y };
//         const cells = getCellsBetween(selection.start, newEnd);
//         if (cells) {
//             setSelection({ ...selection, end: newEnd });
//             setSelectedCells(cells);
//         }
//     };

//     const handleMouseUp = () => {
//         if (selectedCells.length > 0) {
//             const selectedWord = selectedCells.map(cell => grid[cell.x][cell.y]).join("");
//             const reversedWord = selectedWord.split("").reverse().join("");
//             if (MOTS.includes(selectedWord) || MOTS.includes(reversedWord)) {
//                 const matched = MOTS.includes(selectedWord) ? selectedWord : reversedWord;
//                 if (!foundWords.includes(matched)) {
//                     setFoundWords(prev => [...prev, matched]);
//                     setHighlightedCells(prev => [...prev, ...selectedCells]);
//                     const start = selectedCells[0];
//                     const end = selectedCells[selectedCells.length - 1];
//                     drawMissingWordLine(cellRefs.current[start.x][start.y], cellRefs.current[end.x][end.y]);
//                 }
//             } else {
//                 if (selectedWord.length > 3) {
//                     setWrongWords(prev => [...prev, selectedWord]);
//                     setErrorCount((prev) => prev + 1);
//                 }
//             }
//         }

//         setSelection({ start: null, end: null });
//         setSelectedCells([]);
//     };

//     function getCellsBetween(start, end) {
//         const dx = end.x - start.x;
//         const dy = end.y - start.y;
//         const length = Math.max(Math.abs(dx), Math.abs(dy));
//         const stepX = dx === 0 ? 0 : dx / Math.abs(dx);
//         const stepY = dy === 0 ? 0 : dy / Math.abs(dy);
//         if (!(dx === 0 || dy === 0 || Math.abs(dx) === Math.abs(dy))) return null;

//         const cells = [];
//         for (let i = 0; i <= length; i++) {
//             const x = start.x + i * stepX;
//             const y = start.y + i * stepY;
//             if (x >= 0 && y >= 0 && x < GRID_SIZE && y < GRID_SIZE) {
//                 cells.push({ x, y });
//             }
//         }
//         return cells;
//     }

//     return (
//         <div className="page-container">
//             <Sidebar />

//             <div className="content-container inGame" id="mixedWords">
//                 <div className="title">
//                     <h4>{theme} - {subTheme} </h4>
//                     <div className="level-infos">
//                         <Timer 
//                             timer={timerIsFinished}
//                             onFinish={() => {
//                                 checkErrors();
//                                 setTimerIsFinished(true);
//                             }}
//                             onSendTime={sendTime}
//                             onGetTime={(getTimeFn) => getTimerTimeRef.current = getTimeFn}
//                             hasLimit={false}
//                         />
//                     </div>
//                 </div>

//                 <div className="game-container launched">
//                     <div className="mixedwords_game_container launched">
//                         <div id="mixedwords_failed_words_container" className="mixedwords_failed_word_container">
//                             {wrongWords.map((mot, index) => (
//                                 <span key={index} className="wrong-word">{mot}</span>
//                             ))}
//                         </div>

//                         <div className="flex-grow-1" id="mixedwords_grid_container">
//                             <div className="grid">
//                                 {grid.map((row, x) =>
//                                     row.map((cell, y) => {
//                                         const isSelected = selectedCells.some(c => c.x === x && c.y === y);
//                                         return (
//                                             <div
//                                                 className={`cell justify-content-center ${isSelected ? "selected" : ""} ${highlightedCells.some(c => c.x === x && c.y === y) ? "text-white" : ""}`}
//                                                 key={`${x}-${y}`}
//                                                 onMouseDown={() => handleMouseDown(x, y)}
//                                                 onMouseEnter={() => handleMouseEnter(x, y)}
//                                                 onMouseUp={handleMouseUp}
//                                                 data-x={x}
//                                                 data-y={y}
//                                                 ref={(el) => {
//                                                     if (!cellRefs.current[x]) cellRefs.current[x] = [];
//                                                     cellRefs.current[x][y] = el;
//                                                 }}
//                                             >
//                                                 {cell}
//                                             </div>
//                                         );
//                                     })
//                                 )}
//                             </div>
//                         </div>
                        
//                         <div id="mixedwords_words_container" className="mixedwords_word_container">
//                             {MOTS.map((mot, idx) =>
//                                 motsPlaces.includes(mot) ? (
//                                     <span
//                                         className={`word ${foundWords.includes(mot) ? "filled" : ""}`}
//                                         data-word={mot}
//                                         key={idx}
//                                     >
//                                         {mot}
//                                     </span>
//                                 ) : null
//                             )}
//                         </div>
//                     </div>
//                 </div>
//                 <EndGameBtn onClick={() => {
//                     if (getTimerTimeRef.current) {
//                         const currentTime = getTimerTimeRef.current();
//                         sendTime(currentTime);
//                     }
//                     checkErrors();
//                     setTimerIsFinished(true);
//                 }} />
//             </div>

//             <AnimatedBg />
//             <GameMenu onSendLeaveGame={sendLeaveGame} />
//             <Popup time={timeElapsed} timerIsFinished={timerIsFinished} errorCount={errorCount} />
//             <LeaveGamePopup popupOpen={leaveGamePopup} onSendLeaveGame={sendLeaveGame} />
//         </div>
//     );
// }
